import { RESET_SELECTION, RESET_SELECTION_AND_LENGTH } from "~/Configurators/common/advancedTranslationUtils";
import { SubstepType } from "~/Configurators/Linear/dtos";
import type { ConfiguratorDefinition } from "~/Configurators/common/v2/StepDefinition";
import * as RailCstic from "./TKDMRailsCstics";
import {
  type AlarHelperTextFactoryParams,
  ExtraConfig,
  HelperCstics,
  InputCstics,
} from "~/Configurators/Rail/components/ConfigureRailSubstep/constants";
import { getCsticNumericValue } from "~/Configurators/common/v2/helper";
import { userIsCustomer } from "~/utils/roles";

export const TKDMRailsDefinition: ConfiguratorDefinition = {
  description: [
    {
      condition: ({ mainKmat }) => {
        return mainKmat.cstics[RailCstic.GuidewayDesign]?.value === "STD";
      },
      value: "configurator.rail.summary.TKDM.description",
    },
    {
      condition: ({ mainKmat }) => {
        return mainKmat.cstics[RailCstic.GuidewayDesign]?.value === "W";
      },
      value: "configurator.rail.summary.TKDM-W.description",
    },
  ],
  mediaUrl: [
    {
      condition: ({ mainKmat }) => {
        return mainKmat.cstics[RailCstic.GuidewayDesign]?.value === "STD";
      },
      value: "configurator.rail.summary.TKDM.image",
    },
    {
      condition: ({ mainKmat }) => {
        return mainKmat.cstics[RailCstic.GuidewayDesign]?.value === "W";
      },
      value: "configurator.rail.summary.TKDM-W.image",
    },
  ],
  pages: [
    {
      name: "configurator.rail.page.1.name",
      enabled: true,
      resetLabel: RESET_SELECTION,
      resetRequiresConfirmation: false,
      substeps: [
        {
          type: SubstepType.Series,

          name: "configurator.rail.step.series.name",
          description: "configurator.rail.step.series.description",

          tiles: [
            {
              name: "configurator.rail.cstic.guidewayDesign.TKDM.title",
              description: "configurator.rail.cstic.guidewayDesign.TKDM.description",
              info: "configurator.rail.cstic.guidewayDesign.TKDM.info",
              imageUrl: "configurator.rail.cstic.guidewayDesign.TKDM.image",
              cstics: [
                {
                  csticName: RailCstic.GuidewayDesign,
                  value: "STD",
                },
              ],
            },
            {
              name: "configurator.rail.cstic.guidewayDesign.TKDM-W.title",
              description: "configurator.rail.cstic.guidewayDesign.TKDM-W.description",
              info: "configurator.rail.cstic.guidewayDesign.TKDM-W.info",
              imageUrl: "configurator.rail.cstic.guidewayDesign.TKDM-W.image",
              cstics: [
                {
                  csticName: RailCstic.GuidewayDesign,
                  value: "W",
                },
              ],
            },
          ],
          tilesPerRow: 4,

          csticsToReset: [RailCstic.GuidewayDesign],

          visible: true,
        },
        {
          type: SubstepType.Size,

          name: "configurator.rail.step.size.name",
          description: "configurator.rail.step.size.description",

          tiles: [
            {
              name: "07",
              cstics: [
                {
                  csticName: RailCstic.Size,
                  value: "07",
                },
              ],
            },
            {
              name: "09",
              cstics: [
                {
                  csticName: RailCstic.Size,
                  value: "09",
                },
              ],
            },
            {
              name: "12",
              cstics: [
                {
                  csticName: RailCstic.Size,
                  value: "12",
                },
              ],
            },
            {
              name: "15",
              cstics: [
                {
                  csticName: RailCstic.Size,
                  value: "15",
                },
              ],
            },
          ],
          tilesPerRow: 12,

          csticsToReset: [RailCstic.Size],

          visible: true,
        },
        {
          type: SubstepType.Accuracy,

          name: "configurator.rail.step.accuracy.name",
          description: "configurator.rail.step.accuracy.description",
          info: "configurator.rail.step.accuracy.info.TKDM",

          tiles: [
            {
              name: "G1",
              cstics: [
                {
                  csticName: RailCstic.Accuracy,
                  value: "G1",
                },
              ],
            },
            {
              name: "G2",
              cstics: [
                {
                  csticName: RailCstic.Accuracy,
                  value: "G2",
                },
              ],
            },
          ],
          tilesPerRow: 6,

          csticsToReset: [RailCstic.Accuracy],

          visible: true,
        },
      ],
    },
    {
      name: "configurator.rail.page.4.name",
      enabled: true,
      resetLabel: RESET_SELECTION_AND_LENGTH,
      resetRequiresConfirmation: false, // TODO CHECK
      substeps: [
        {
          type: SubstepType.Closure,
          visible: true,

          name: "configurator.rail.step.closure.name",
          info: "configurator.rail.step.closure.info",
          groupedTiles: [
            {
              name: "configurator.rail.step.closure.section.plugs.name",
              visible: true,
              tiles: [
                {
                  name: "configurator.rail.cstic.closure.NONE.name",
                  cstics: [
                    {
                      csticName: RailCstic.ClosingPlugs,
                      value: "NONE",
                    },
                  ],
                },
                // {
                //   name: "configurator.rail.cstic.closure.KA-TN.name",
                //   description: "configurator.rail.cstic.closure.KA-TN.description",
                //   imageUrl: "configurator.rail.cstic.closure.KA-TN.imageUrl",
                //   info: "configurator.rail.cstic.closure.KA-TN.info",
                //   cstics: [
                //     {
                //       csticName: RailCstic.ClosingPlugs,
                //       value: "KA..TN",
                //     },
                //   ],
                // },
              ],
            },
          ],
          tilesPerRow: 6,
          csticsToReset: [RailCstic.ClosingPlugs],
        },
        {
          type: SubstepType.ConfigureRail,
          visible: true,

          name: "configurator.rail.page.4.name",

          extraTexts: {
            lowerMessage: "configurator.rail.step.guidewaySet.infoMessage.lower",
            lengthName: "configurator.rail.cstic.guidewayLength.name", // TODO - Move to cstic
            lengthInfo: "configurator.rail.cstic.guidewayLength.info", // TODO - Move to cstic
            alarName: "configurator.rail.section.alar.name",
            alarInfo: "configurator.rail.section.alar.info",
            alarRecommended: "configurator.rail.section.alar.recommended",
            alarWarningMessage: "configurator.rail.section.alar.warning",
            partsSectionName: "configurator.rail.section.parts.name",
            partsSectionInfo: "configurator.rail.section.parts.info",
          },

          inputCstics: {
            [InputCstics.TotalLength]: {
              name: RailCstic.GuidewayLength,
              required: true,
            },
            [InputCstics.aL]: {
              name: RailCstic.AL,
              visible: [
                {
                  condition: ({ mainKmat }) => {
                    return getCsticNumericValue(mainKmat, RailCstic.GuidewayLength) > 0;
                  },
                  value: true,
                },
                {
                  condition: () => true,
                  value: false,
                },
              ],
            },
            [InputCstics.aR]: {
              name: RailCstic.AR,
              visible: [
                {
                  condition: ({ mainKmat }) => {
                    return getCsticNumericValue(mainKmat, RailCstic.GuidewayLength) > 0;
                  },
                  value: true,
                },
                {
                  condition: () => true,
                  value: false,
                },
              ],
            },
            [InputCstics.partSizingType]: {
              name: RailCstic.PartSizing,
              disabled: true,
              visible: [
                {
                  condition: ({ mainKmat }) => {
                    return getCsticNumericValue(mainKmat, RailCstic.GuidewayLength) > 0;
                  },
                  value: true,
                },
                {
                  condition: () => true,
                  value: false,
                },
              ],
            },
            [InputCstics.partAmount]: {
              name: RailCstic.PartAmount,
              disabled: true,
              visible: [
                {
                  condition: ({ mainKmat }) => {
                    return getCsticNumericValue(mainKmat, RailCstic.GuidewayLength) > 0;
                  },
                  value: true,
                },
                {
                  condition: () => true,
                  value: false,
                },
              ],
            },
          },

          helperCstics: {
            [HelperCstics.totalLengthMin]: {
              name: RailCstic.GuidewayLengthMin,
            },
            [HelperCstics.totalLengthMax]: {
              name: RailCstic.GuidewayLengthMax,
            },
            [HelperCstics.alHardMax]: {
              name: RailCstic.FixedHoleDistance,
            },
            [HelperCstics.arHardMax]: {
              name: RailCstic.FixedHoleDistance,
            },
            [HelperCstics.alRecommendedMin]: {
              name: RailCstic.ALMin,
            },
            [HelperCstics.alRecommendedMax]: {
              name: RailCstic.ALMax,
            },
            [HelperCstics.arRecommendedMin]: {
              name: RailCstic.ARMin,
            },
            [HelperCstics.arRecommendedMax]: {
              name: RailCstic.ARMax,
            },
          },

          extraConfig: {
            [ExtraConfig.AlarHelperTextFactory]: ({
              hardMin = 0,
              hardMax = 0,
              recommendedMin = 0,
              recommendedMax = 0,
              t,
              value,
            }: AlarHelperTextFactoryParams) => {
              if (value === null) {
                return `${t("common.min")} ${recommendedMin} / ${t("common.recommended")} ${recommendedMax}`;
              }
              if (value <= hardMin) {
                return "<=mm";
              }
              if (value > hardMax) {
                return `>${hardMax}mm`;
              }

              return `${t("common.min")} ${recommendedMin} / ${t("common.recommended")} ${recommendedMax}`;
            },
          },

          csticsToReset: [RailCstic.GuidewayLength, RailCstic.AL, RailCstic.AR],
        },
      ],
    },
    {
      name: "configurator.rail.page.5.name",
      enabled: true,
      resetLabel: "",
      resetRequiresConfirmation: false,
      substeps: [
        {
          type: SubstepType.SummaryPage,
          visible: true,

          info: [
            {
              condition: ({ mainKmat }) => {
                return userIsCustomer();
              },
              value: "configurator.rail.summary.info.above.business",
            },
            {
              condition: ({ mainKmat }) => {
                return true;
              },
              value: "configurator.rail.summary.info.above.plus",
            },
          ],
        },
      ],
    },
  ],
};
